import(/* webpackMode: "eager" */ "/var/www/tipanonymous/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"700\"],\"style\":\"normal\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/var/www/tipanonymous/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/var/www/tipanonymous/frontend/src/app/provider.tsx");
